// Contract 29 §9 / §3.4 — resolve how one legal slug must be presented.
//
// BE-29-01 (`GET /legal/documents/{slug}?locale=`) does not exist yet, so `mode` never resolves to
// `'modal'` today. That is deliberate: a stub fetch would either invent prose or render a blank
// modal on a consent screen, and §14.14 forbids both. When the endpoint lands, only this file and
// `LegalDocumentModal` change — the signup screen already branches on `mode`.

import { computed, type ComputedRef } from 'vue'

import {
  LEGAL_HREFS,
  type LegalDocument,
  type LegalDocumentMode,
  type LegalDocumentSlug,
} from '../models/legal.types'

export interface UseLegalDocument {
  mode: ComputedRef<LegalDocumentMode>
  /** Only ever read when `mode === 'external'`. Empty otherwise, never a dead `#`. */
  href: ComputedRef<string>
  document: ComputedRef<LegalDocument | null>
}

export function useLegalDocument(slug: LegalDocumentSlug): UseLegalDocument {
  const href = computed(() => LEGAL_HREFS[slug] ?? '')
  return {
    mode: computed<LegalDocumentMode>(() => (href.value ? 'external' : 'unavailable')),
    href,
    // BE-29-01 has no producer; the type exists so the consumer is already written against it.
    document: computed(() => null),
  }
}
